import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre1/", true, /\.webp/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre2/", true, /\.webp/)); }
const Torre3 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre3/", true, /\.webp/)); }
const Torre6 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre6/", true, /\.webp/)); }

export const ContextLoader = {
    "General View": GeneralView,
    "Torre 1": Torre1,
    "Torre 2": Torre2,
    "Torre 3": Torre3,
    "Torre 6": Torre6,
}
